import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "Home" */ '../views/Home.vue')
  },
  {
    path: '/homeloggedin',
    name: 'HomeLoggedIn',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "HomeLoggedIn" */ '../views/HomeLoggedIn.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import(/* webpackChunkName: "About" */ '../views/About.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import(/* webpackChunkName: "Contact" */ '../views/Contact.vue')
  },
  {
    path: '/contactthanks',
    name: 'ContactThankYou',
    component: () => import(/* webpackChunkName: "ContactThanks" */ '../views/ContactThankYou.vue')
  },
  {
    path: '/contactthankspending',
    name: 'ContactThankYouPending',
    component: () => import(/* webpackChunkName: "ContactThanksPending" */ '../views/ContactThankYouPending.vue')
  },
  {
    path: '/request',
    name: 'Request',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "Request" */ '../views/RequestKits.vue')
  },
  {
    path: '/requestthanks',
    name: 'RequestKitsThankYou',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "Request" */ '../views/RequestKitsThankYou.vue')
  },
  {
    path: '/curriculum',
    name: 'Curriculum',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "Curriculum" */ '../views/Curriculum.vue')
  },
  {
    path: '/login',
    name: 'LogIn',
    component: () => import(/* webpackChunkName: "LogIn" */ '../views/LogIn.vue'),
    props: true
  },
  {
    path: '/signupthanks',
    name: 'SignUpThanks',
    component: () => import(/* webpackChunkName: "SignUp" */ '../views/SignUpThanks.vue'),
    props: true
  },
  {
    path: '/signup',
    name: 'SignUp',
    component: () => import(/* webpackChunkName: "SignUp" */ '../views/SignUp.vue')
  },
  {
    path: '/account',
    name: 'AccountDetail',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "AccountDetail" */ '../views/AccountDetail.vue')
  },
  {
    path: '/editaccount',
    name: 'EditAccountDetails',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "EditAccountDetail" */ '../views/EditAccountDetails.vue')
  },
  {
    path: '/neweditaccount',
    name: 'NewEditAccountDetails',
    component: () => import(/* webpackChunkName: "NewEditAccountDetails" */ '../views/NewEditAccountDetails.vue')
  },
  {
    path: '/orderhistory',
    name: 'OrderHistory',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "OrderHistory" */ '../views/OrderHistory.vue')
  },
  {
    path: '/orderdetails/:id',
    name: 'OrderDetails',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "OrderDetail" */ '../views/OrderDetails.vue')
  },
  {
    path: '/changepassword',
    name: 'ChangePassword',
    component: () => import(/* webpackChunkName: "ChangePassword" */ '../views/ChangePassword.vue')
  },
  {
    path: '/forgotpassword',
    name: 'ForgotPassword',
    component: () => import(/* webpackChunkName: "ForgotPassword" */ '../views/ForgotPassword.vue'),
    props: true
  },
  {
    path: '/forgotpasswordthanks',
    name: 'ForgotPasswordThanks',
    component: () => import(/* webpackChunkName: "ForgotPasswordThanks" */ '../views/ForgotPasswordThanks.vue')
  },
  {
    path: '/:catchAll(.*)',
    name: 'Not Found',
    component: () => import(/* webpackChunkName: "NotFound" */ '../views/Home.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.VUE_APP_BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        // resolve({ x: 0, y: 0 })
        if (to.hash) {
          resolve({ selector: to.hash })
        } else {
          resolve({ x: 0, y: 0 })
        }
      }, 200)
    })
  }
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!window.localStorage.getItem('auth_token') || Date.now() > parseInt(window.localStorage.getItem('auth_ttl'))) {
      next({
        name: 'LogIn',
        params: { successRoute: to.name }
      })
    } else {
      if (window.localStorage.getItem('auth_token')) {
        // Only update the auth token if there's a value in the window.
        router.app.axios.defaults.headers.common.Authorization = 'Bearer ' + window.localStorage.getItem('auth_token')
      }
      next()
    }
  } else {
    next() // make sure to always call next()!
  }
})

export default router
